import React from "react";
import { TableContainer, Paper, Container } from "@mui/material";
import { Typography, Box } from "@mui/material";

function Contact() {
  function DisplayContact() {
    //This is the flex items
    return (
      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          maxWidth: "48%",
          minWidth: "900px",
          maxHeight: "600px",
          minHeight: "400px",
          flexGrow: 1,
          p: 1,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Contact Information and Support Line for Specific Features:
        </Typography>
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            margin: "0 auto",
            maxHeight: 400,
            overflow: "auto",
          }}
        >
          <div style={{ backgroundColor: "#e5e5e5" }}>
            {" "}
            <div
              name="space"
              style={{ width: "100%", height: "40px", flex: "0 1 auto" }}
            ></div>
            <Container maxWidth="sm">
              <Typography variant="h6" gutterBottom>
                Back End: Curtis@investin.org <br></br>
                Front End: Curtis@investin.org <br></br>
                MongoDB Database: Curtis@investin.org <br></br>
                Design: Curtis@investin.org <br></br>
                Testing: Curtis@investin.org <br></br>
                Deployment: Curtis@investin.org <br></br>
                Maintenance: Curtis@investin.org <br></br>
                Support: Curtis@investin.org <br></br>
                Documentation: Curtis@investin.org <br></br>
                Staff Service: Curtis@investin.org <br></br>
                Customer Service: Curtis@investin.org <br></br>
                EC Service: Curtis@investin.org <br></br>
                Attendee Service: Curtis@investin.org <br></br>
                Legal: Curtis@investin.org <br></br>
                Compliance: Curtis@investin.org <br></br>
                Security: Curtis@investin.org <br></br>
                Cyber Security: Curtis@investin.org <br></br>
                Privacy: Curtis@investin.org <br></br>
                Accessibility: Curtis@investin.org <br></br>
                Line Manager: Caitlin@investin.org
                <br></br>{" "}
              </Typography>
              <br></br>
            </Container>
          </div>
        </TableContainer>
      </Box>
    );
  }

  return (
    <div style={{ backgroundColor: "#e5e5e5", minHeight: "93vh" }}>
      {/* This is the flex container */}
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "space-around",
          gap: "20px",
          backgroundColor: "#e5e5e5",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "60px", flex: "0 1 auto" }}
        ></div>
        <DisplayContact style={{ flex: "0 1 auto" }} />
      </div>
    </div>
  );
}

export default Contact;
